import React from 'react';

import ParseHtml from 'html-react-parser';
import { IconDocument, IconFile } from '@bynder/icons';
import { Guideline, SearchItem, SearchResults } from '../../../types';
import { calculateHeightStyle } from './calculateHeightStyle';
import { iconSizeExtraLarge, iconSizeMedium } from '../../../helpers/iconSizes';
import { StyledSearchItem } from '../styles';

interface Props {
	searchTerm: string;
	results: SearchResults;
	currentActiveSearchItem?: SearchItem;
}

export function GroupGuidelines({ searchTerm, results, currentActiveSearchItem }: Props) {
	const guidelines = results.guidelines.items;
	const redirectionUrl = `/guidelines/search?type=all&key=${encodeURIComponent(
		searchTerm,
	)}&from=1970-01-01T00:00:00.000Z&page=0`;

	return (
		<>
			<li className="">
				<a href={redirectionUrl} className="header">
					<IconDocument size={iconSizeMedium} />
					{' Guidelines/Landing pages for '}
					<b> {searchTerm} </b>
					<span> {guidelines.length} </span>
				</a>
			</li>

			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul>
					{guidelines.map((guideline: Guideline) => (
						<StyledSearchItem
							className="spotlight-collection"
							isItemSelected={guideline.id === currentActiveSearchItem?.id}
							data-id=""
							data-src="DOCUMENT-ICON"
							data-close-on-click="1"
							key={guideline.title}
						>
							<a href={guideline.path}>
								{guideline.iconSvg ? (
									<div className="searchbox-img">
										{ParseHtml(guideline.iconSvg)}
									</div>
								) : (
									<div className="searchbox-img">
										<IconFile size={iconSizeExtraLarge} />
									</div>
								)}

								<p className="searchbox-title">{ParseHtml(guideline.title)}</p>
							</a>
						</StyledSearchItem>
					))}
				</ul>
			</div>
		</>
	);
}
